import $ from 'jquery'
import { Application } from 'backbone.marionette'
import Products from './collections/products'
import Product from './models/product'
import AddToCartQuantityView from './views/addtocart-quantity'
import ProductSubstratesView from './views/substrates'
import ProductTrimsView from './views/trims'
import SubtotalView from './views/subtotal'

class ProductSubtotalCalculator extends Application {}

const app = new ProductSubtotalCalculator()

app.on('start', function () {
  const mainProduct = new Product({
    id: window.item.id
  })

  const allProducts = new Products(
    window.pcRelatedBundledItemIds.map((itemId) => ({
      id: itemId
    }))
  )
  allProducts.add(mainProduct)

  $('.addtocart-quantity').each(function () {
    const itemId = $(this).data('itemid')
    new AddToCartQuantityView({
      // For the view bindings, we need the `select` to be a child of `el`
      el: $(this).parent(),
      model: allProducts.findWhere({ id: itemId })
    })
  })

  const $productSubstrates = $('.product-substrates')
  if ($productSubstrates.length) {
    new ProductSubstratesView({
      el: $productSubstrates,
      model: mainProduct
    })
  }

  const $productTrims = $('.product-trims')
  if ($productTrims.length) {
    new ProductTrimsView({
      el: $productTrims,
      model: mainProduct
    })
  }

  const $subtotalSection = $('.subtotal-section')
  if ($subtotalSection.length) {
    return new SubtotalView({
      el: $subtotalSection,
      collection: allProducts
    })
  }
})

export default app
